import React from "react";
import { Container } from "@material-ui/core";

//import Header from 'components/Public/Header2'
//import Footer from 'pages/Public/Footer'
import Header from "components/Public/Header";
import Footer from "components/Public/Footer";
import { Card, CardHeader, CardBody } from "components/Card";

// @ts-ignore
export default function Register(): JSX.Element {
  return (
    <React.Fragment>
      <Header />
      <div className="py-4 pt-md-6 py-md-5 bg-black bg-op-3"></div>
      <div className="py-4 pt-md-6 py-md-5 bg-primary-faded bg-op-1">
        <Container maxWidth="md">
          <Card>
            <CardHeader>
              <h4>Aviso de Privacidad</h4>
            </CardHeader>
            <CardBody>
              <p>
                What is Lorem Ipsum? Lorem Ipsum is simply dummy text of the
                printing and typesetting industry. Lorem Ipsum has been the
                industry&apos;s standard dummy text ever since the 1500s, when
                an unknown printer took a galley of type and scrambled it to
                make a type specimen book. It has survived not only five
                centuries, but also the leap into electronic typesetting,
                remaining essentially unchanged. It was popularised in the 1960s
                with the release of Letraset sheets containing Lorem Ipsum
                passages, and more recently with desktop publishing software
                like Aldus PageMaker including versions of Lorem Ipsum.
              </p>
              <p>
                What is Lorem Ipsum? Lorem Ipsum is simply dummy text of the
                printing and typesetting industry. Lorem Ipsum has been the
                industry&apos;s standard dummy text ever since the 1500s, when
                an unknown printer took a galley of type and scrambled it to
                make a type specimen book. It has survived not only five
                centuries, but also the leap into electronic typesetting,
                remaining essentially unchanged. It was popularised in the 1960s
                with the release of Letraset sheets containing Lorem Ipsum
                passages, and more recently with desktop publishing software
                like Aldus PageMaker including versions of Lorem Ipsum.
              </p>
            </CardBody>
          </Card>
        </Container>
      </div>
      <Footer />
    </React.Fragment>
  );
}
